export function onRowSelectionChanged(grid, callback, props) {
	if (callback) {
		grid.wrapper.on('change', '.cw_grid_check', (e) => {
			const data = grid.dataItem($(e.target).closest('tr'));
			callback(data[props.selectionField]);
		});
	}
}
